import { render, staticRenderFns } from "./CustomerItemList.vue?vue&type=template&id=335145a3&scoped=true"
import script from "./CustomerItemList.vue?vue&type=script&lang=ts"
export * from "./CustomerItemList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335145a3",
  null
  
)

export default component.exports